"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontSizeMixin = void 0;
var _styledToken = _interopRequireDefault(require("styled-token"));
var _addSuffix = require("../util/addSuffix");
/** @mixin fontSizeMixin */
/**
 * Get the font size for the given font type.
 *
 * @example
 * import { fontSizeMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     font-size: ${fontSizeMixin('h1')};
 * `;
 *
 * <Component>h1 font size</Component>
 *
 * @method
 * @param {string} fontType - The `fontType` key for the `fontSizes` object.
 * @param {function} [callback] - An optional callback that will be called with an object with the
 *     font size value and suffix properties. The value returned from the function will be inserted.
 * @return {Interpolation}
 */
var fontSizeMixin = function fontSizeMixin(fontType, callback) {
  return (0, _styledToken.default)({
    fontSizes: 'fontSizes',
    suffix: 'defaultUnit'
  }, function (_ref) {
    var fontSizes = _ref.fontSizes,
      suffix = _ref.suffix;
    var value = fontSizes && fontSizes[fontType];
    if (typeof callback === 'function') {
      return callback({
        value: value,
        suffix: suffix
      });
    }
    return (0, _addSuffix.addSuffix)(value, suffix);
  });
};
exports.fontSizeMixin = fontSizeMixin;